module.exports = __webpack_public_path__ + "static/media/preference-profession-online-shopper.a4943e17.png";